<template>
    <div
        :class="[
            {
                'has-error': v && v.$anyError,
                'is-required': isRequired,
            },
            classes,
        ]"
        class="field fileInput"
        :disabled="iniDisabled">
        <label class="label" v-if="label">{{ label }}</label>

        <div class="control is-expanded">
            <!-- Upload -->
            <template v-if="!iniDisabled">
                <div class="section blank">
                    <!-- Is Uploading -->
                    <div v-if="isUploading" class="has-text-centered">
                        <loader :text="$t('uploadingDocuments')" />
                        <b-progress size="is-small is-success" :value="progress"></b-progress>
                    </div>
                    <!-- Select file(s) -->
                    <template v-else>
                        <template v-if="showSelectButton">
                            <b-upload
                                v-model="uploadModel"
                                @input="onUploadFilesChoosen"
                                :accept="typeLimit.join(',')"
                                :multiple="isMultiple"
                                :drag-drop="isDragDrop">
                                <template v-if="isDragDrop">
                                    <div class="content has-text-centered">
                                        <font-awesome-icon :icon="['fas', 'cloud-upload-alt']" />
                                        <p>
                                            {{ $t('drop-your-files-here-or-click-to-upload') }}
                                        </p>
                                    </div>
                                </template>
                                <template v-else>
                                    <div
                                        :class="{
                                            'text-center': enableExistingDocuments,
                                        }">
                                        <span class="button is-cancel">
                                            <span class="icon">
                                                <font-awesome-icon :icon="['fas', 'cloud-upload-alt']" />
                                            </span>
                                            <span>{{ $t(isMultiple ? 'selectDocuments' : 'selectDocument') }}</span>
                                        </span>
                                    </div>
                                </template>
                            </b-upload>
                            <!--
                            <template v-if="enableExistingDocuments">
                                <div class="txt-divider">
                                    <span>
                                        {{ $t("documents.orAddExistingFiles") }}
                                    </span>
                                </div>
                                <documentChooser
                                    @input="onExistingDocument"
                                    :iniDisabled="false"
                                    :isMultiple="true"
                                    :showSelectedFiles="false"
                                    :showProperties="showProperties"
                                    :targetId="targetId"
                                    :targetType="targetType"
                                />
                            </template>-->
                        </template>
                    </template>
                </div>
            </template>

            <!--No value and disabled-->
            <template v-else-if="showNoValueDisabled">
                <textInput :iniDisabled="true" />
            </template>

            <!-- has value -->
            <div class="thumbnail-list">
                <!--existing Files-->
                <template v-if="selected">
                    <template v-for="(file, index) in selected.files.slice(0, slicerCount)">
                        <thumbnail
                            :class="{
                                'has-popover': usePopover,
                                'is-success': file.isAdded,
                            }"
                            :key="`file_${index}`"
                            :data="file"
                            :renderType="renderType"
                            :showPreview="showPreview"
                            :showProperties="showProperties"
                            :addClick="showCarousel"
                            @click="onThumbailClick">
                            <div class="actions d-flex v-center h-center">
                                <button
                                    v-if="(file.id || file.fileId) && !hideDetail"
                                    class="button is-detailMenu on-hover"
                                    @click.prevent="onDetailClick(file)">
                                    <font-awesome-icon :icon="['fas', 'eye']" />
                                </button>
                                <template v-if="!iniDisabled">
                                    <button class="button is-danger is-small on-hover" @click="doDelete(index)">
                                        <font-awesome-icon :icon="['fas', 'trash-alt']" />
                                    </button>
                                </template>
                            </div>
                            <!--Edit properties
                            <template v-if="editProperties.length > 0">
                                <div class="flex-break"></div>
                                <documentProperties
                                    :editProperties="editProperties"
                                    v-model="file.properties"
                                />
                            </template>-->
                        </thumbnail>
                    </template>
                    <a href="" class="ml5-xs" @click.prevent="showCarouselModal = true" v-if="usePopover">
                        <b-tag type="is-success">+ {{ selected.files.length - 1 }}</b-tag>
                    </a>
                </template>

                <!--Uploads show only when not disabled and not uploading-->
                <template v-if="uploads && uploads.length > 0 && !iniDisabled && !isUploading">
                    <template v-for="(file, index) in uploads">
                        <thumbnail
                            :data="file"
                            :renderType="renderType"
                            :showPreview="showPreview"
                            :showProperties="showProperties"
                            :key="`upload_${index}`"
                            :class="[
                                'is-success',
                                {
                                    'is-danger': file.toobig,
                                },
                            ]">
                            <div class="actions">
                                <template v-if="!iniDisabled">
                                    <button
                                        type="button"
                                        class="is-danger button is-small"
                                        @click.prevent="doDeleteUpload(index)">
                                        <font-awesome-icon :icon="['fas', 'trash-alt']" />
                                    </button>
                                </template>
                                <template v-else>
                                    <span class="button is-close is-static">
                                        <font-awesome-icon :icon="['fas', 'cloud-upload-alt']" />
                                    </span>
                                </template>
                            </div>
                            <!--Edit properties
                            <template v-if="editProperties.length > 0">
                                <div class="flex-break"></div>
                                <documentProperties
                                    :editProperties="editProperties"
                                    v-model="file.properties"
                                />
                            </template>-->

                            <!--Too big notification-->
                            <template v-if="file.toobig">
                                <div class="flex-break"></div>
                                <b-tag type="is-danger" class="mx10-xs">
                                    {{
                                        $t('notAllowedSize', {
                                            size: (file.size * 0.000001).toFixed(1),
                                        })
                                    }}</b-tag
                                >
                            </template>
                        </thumbnail>
                    </template>
                </template>
            </div>
        </div>

        <span v-if="v && v.$anyError" class="help is-danger">
            <slot name="onError" />
        </span>
        <span class="help info" v-if="!!this.$slots.help">
            <slot name="help" />
        </span>

        <!--Carousel Modal if enabled by Prop-->
        <template v-if="selected && selected.files && showCarousel">
            <modal :value="showCarouselModal" :showFooter="false">
                <template v-slot:content>
                    <b-carousel
                        :indicator-inside="false"
                        :indicator="selected.files.length > 1"
                        :arrow="selected.files.length > 1">
                        <b-carousel-item v-for="(item, i) in selected.files" :key="i">
                            <span class="image">
                                <img :src="item.src" />
                            </span>
                        </b-carousel-item>
                    </b-carousel>
                    <div class="text-center mt15-xs">
                        <button class="button is-cancel" @click.prevent="showCarouselModal = false">
                            {{ $t('close') }}
                        </button>
                    </div>
                </template>
            </modal></template
        >
    </div>
</template>

<script>
import modal from './modal.vue';

//todo: documentchooser and properties are currently disabled
import thumbnail from './../components/DocumentThumbnail.vue';
import { processFile } from './../mixins/helpers.js';
/*const documentChooser = () =>
    import("@/modules/Documents/components/DocumentsChooser.vue");*/
/*const documentProperties = () =>
    import("@/modules/Documents/components/DocumentProperties.vue");*/

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCloudUploadAlt, faEye, faTrashAlt, faTimeline } from '@fortawesome/free-solid-svg-icons';

library.add(faCloudUploadAlt);
library.add(faEye);
library.add(faTrashAlt);
library.add(faTimeline);

export default {
    name: 'fileInput',
    components: { thumbnail, modal, FontAwesomeIcon /*documentChooser, documentProperties*/ },
    props: {
        v: [Object, Function],
        label: String,
        iniDisabled: { type: Boolean, default: false },
        value: [Object],
        classes: String,
        isMultiple: { type: Boolean, default: false },
        condensed: { type: Boolean, default: false },
        progress: { type: Number },
        sizeLimit: { type: Number, default: 0 },
        typeLimit: {
            type: Array,
            default: function () {
                return [];
                //return ["image/jpeg", "image/png", "image/gif"];
            },
        },
        renderType: { type: String, default: 'THUMBNAIL' },
        isDragDrop: { type: Boolean, default: true },
        hideDetail: { type: Boolean, default: false },
        showPreview: { type: Boolean, default: true },
        showCarousel: { type: Boolean, default: true },
        showProperties: {
            type: Array,
            default: function () {
                return [];
            },
        },
        editProperties: {
            type: Array,
            default: function () {
                return [];
            },
        },
        enableExistingDocuments: { type: Boolean, default: true },
        targetId: { type: String }, //for existingdocuments
        targetType: { type: String }, //for existingdocuments
    },
    data() {
        return {
            selected: null,
            isUploading: false,

            uploads: [],
            uploadModel: [], //not used, only for b-upload

            showCarouselModal: false,
        };
    },
    computed: {
        showSelectButton() {
            if (!this.isMultiple && this.selected) {
                //single value
                if (this.selected.files.length > 0) {
                    //dont show if there is a file
                    return false;
                } else if (this.validUploads() && this.validUploads().length > 0) {
                    //dont show if one valid is selected
                    return false;
                }
            }
            return true;
        },
        showNoValueDisabled() {
            if (!this.selected) {
                return true;
            }
            if (this.iniDisabled) {
                if (this.isMultiple) {
                    return this.selected && this.selected.files && this.selected.files.length == 0;
                } else {
                    return this.selected.files.length > 0 ? false : true;
                }
            }
            return false;
        },
        usePopover() {
            if (this.condensed && this.iniDisabled) {
                if (Array.isArray(this.selected.files) && this.selected.files.length > 1) {
                    return true;
                }
            }
            return false;
        },
        slicerCount() {
            if (this.condensed && this.iniDisabled) {
                return 1;
            }
            return this.selected.files.length;
        },
        isRequired() {
            return this.v && this.v.required === false;
        },
    },
    watch: {
        value() {
            this.handleValue();
        },
    },
    created() {
        this.handleValue();
        if (this.$eventHub) {
            this.$eventHub.$on('fileInput_' + this._uid + '.isUploading', this.onUploading);
            this.$eventHub.$on('fileInput_' + this._uid + '.isSuccess', this.onUploadSuccess);
        }
    },
    beforeDestroy() {
        if (this.$eventHub) {
            this.$eventHub.$off('fileInput_' + this._uid + '.isUploading', this.onUploading);
            this.$eventHub.$off('fileInput_' + this._uid + '.isSuccess', this.onUploadSuccess);
        }
    },
    methods: {
        processFile,
        validUploads() {
            return this.uploads.filter((x) => {
                return !x.toobig;
            });
        },
        checkSize(processed) {
            //check size
            let sizeMB = (processed.size * 0.000001).toFixed(1);
            if (this.sizeLimit > 0 && sizeMB >= this.sizeLimit) {
                processed.toobig = true;
            }
            return processed;
        },
        handleValue() {
            if (this.value) {
                this.selected = JSON.parse(JSON.stringify(this.value));
                if (this.value.uploads) {
                    var rejectedValues = this.uploads.filter((x) => {
                        return x.toobig;
                    }); //add the rejected ones...
                    this.uploads = [...rejectedValues, ...this.value.uploads];
                }
            }

            //handle no values
            if (this.selected && !this.selected.files) {
                this.selected.files = [];
            }
            if (this.selected && !this.selected.uploads) {
                this.selected.uploads = [];
                this.uploadModel = [];
            }

            if (!this.value && this.selected) {
                this.selected = {
                    files: [],
                    uploads: [],
                };
                this.uploads = [];
                this.uploadModel = [];
            }
        },
        async onUploadFilesChoosen(result) {
            if (Array.isArray(result)) {
                //multiple files
                this.uploads = [];
                let promises = result.map((x) => {
                    return this.processFile(x);
                });
                //check size
                var results = await Promise.all(promises);
                this.uploads = results.map((x) => {
                    return this.checkSize(x);
                });
            } else if (result) {
                //1 file
                var processed = await this.processFile(result);
                //check size
                processed = this.checkSize(processed);
                if (this.isMultiple) {
                    this.uploads.push(processed);
                } else {
                    this.uploads = [processed];
                }
            } else {
                //no result... because of typeLimit
                console.info('Filetype not supported');
            }
            this.emitInput();
        },
        emitInput() {
            //update v-model
            this.$emit('input', {
                uploads: this.validUploads(),
                files: this.selected ? this.selected.files : [],
                eventHandlerName: 'fileInput_' + this._uid,
            });
        },
        doDeleteUpload(index) {
            this.uploads.splice(index, 1);
            this.selected.uploads.splice(index, 1);
            if (Array.isArray(this.uploadModel)) {
                this.uploadModel.splice(index, 1);
            }

            //update v-model
            this.$emit('input', {
                uploads: this.validUploads(),
                files: this.selected.files,
                eventHandlerName: 'fileInput_' + this._uid,
            });
        },
        doDelete(index) {
            let removedFile = this.selected.files[index];
            this.$emit('delete', removedFile);

            this.selected.files.splice(index, 1);
            //update v-model
            var result = {
                uploads: this.validUploads(),
                files: this.selected.files,
                eventHandlerName: 'fileInput_' + this._uid,
            };
            this.$emit('input', result);
        },
        onUploading() {
            this.isUploading = true;
        },
        onUploadSuccess() {
            this.reset();
        },
        onDetailClick(item) {
            if (this.showCarousel) {
                this.showCarouselModal = true;
            } else {
                var fileId = item.fileId ? item.fileId : item.id ? item.id : null;
                if (fileId) {
                    this.$detailMenu.$emit('showDetailMenu', {
                        id: fileId,
                        type: 'DOCUMENT',
                        meta: { title: item.fileName, parentIds: item.parentIds },
                    });
                }
            }
        },
        onThumbailClick() {
            if (this.showCarousel) {
                this.showCarouselModal = true;
            }
        },
        onExistingDocument(document) {
            var document = document[0];
            if (document) {
                document.isAdded = true;
                //init this.selected.files if not already created
                if (!this.selected) {
                    this.selected = {};
                }
                if (!this.selected.files) {
                    this.selected.files = [];
                }
                //add the file
                this.selected.files.push(document);
            }
            //emit the changes
            this.emitInput();
        },
        reset() {
            this.uploads = [];
            this.uploadModel = [];
            this.isUploading = false;
        },
    },
    i18n: {
        messages: {
            en: {
                notAllowedSizeAndType: 'Size {size} MB and type {type} is not supported',
                notAllowedType: 'File type {type} is not supported',
                notAllowedSize: 'Size {size} MB  is not supported',
                selectDocuments: 'Select documents',
                selectDocument: 'Select document',
                uploadingDocuments: 'Upload documents',
                'drop-your-files-here-or-click-to-upload': 'Drop your files here or click to upload.',
                close: 'Close',
            },
            fr: {
                notAllowedSizeAndType: 'La taille {size} Mo et le type {type} ne sont pas pris en charge',
                notAllowedType: "Le type de fichier {type} n'est pas pris en charge",
                notAllowedSize: "La taille {size} Mo n'est pas prise en charge",
                selectDocuments: 'Sélectionner des documents',
                selectDocument: 'Sélectionner un document',
                uploadingDocuments: 'Téléchargement de documents',
                'drop-your-files-here-or-click-to-upload': 'Déposez vos fichiers ici ou cliquez pour télécharger.',
                close: 'Fermer',
            },
            nl: {
                notAllowedSizeAndType: 'Grootte {grootte} MB en type {type} wordt niet ondersteund',
                notAllowedType: 'Bestandstype {type} wordt niet ondersteund',
                notAllowedSize: 'Grootte {grootte} MB wordt niet ondersteund',
                selectDocuments: 'Selecteer documenten',
                selectDocument: 'Selecteer document',
                uploadDocuments: 'Upload documenten',
                'drop-your-files-here-or-click-to-upload': 'Drop uw bestanden hier of klik om te uploaden.',
                close: 'Sluiten',
            },
        },
    },
};
</script>

<style lang="scss">
.fileInput {
    .thumbnail-list {
        display: flex;
        align-items: center;

        .thumbnail {
            padding: 5px;
            width: 125px;
            height: 125px;
            overflow: hidden;

            .image {
                max-width: 85px;
                max-height: 85px;
                overflow: hidden;
            }

            &.is-success {
                border: 2px solid var(--success);
                background-color: var(--success-lighten-90);
            }

            &.is-danger {
                border: 2px solid var(--danger);
                background-color: var(--danger-lighten-90);
            }

            .actions {
                margin-top: 0;

                .actions {
                    margin-top: 10px;
                }
            }
        }

        .thumbnail-listitem {
            .actions {
                margin-left: auto;
            }

            &.is-success {
                padding: 10px;
                border-bottom-color: var(--success);
                background-color: var(--success-lighten-90);
            }

            &.is-danger {
                padding: 10px;
                border-bottom-color: var(--danger);
                background-color: var(--danger-lighten-90);
            }
        }
    }
}
.thumbnail-listitem {
    background-color: #fff;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    box-shadow: none;
    border: 0;
    padding: 7px 0 5px;
    border-bottom: 2px solid var(--background-color-darker);
    flex: 1 1 auto;
    flex-wrap: wrap;
    min-width: 200px;
    width: 100%;

    .on-hover {
        transition: all 0.15s ease-in-out;
        opacity: 0;
    }

    &:hover {
        .on-hover {
            opacity: 1;
        }
    }

    .name {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        max-width: 70%;
        display: block;
    }

    span.icon {
        svg.svg-inline--fa {
            color: #cfcfcf;
        }
    }

    .image {
        flex-wrap: wrap;
        margin-right: 15px;

        .image-box {
            width: 76px;
            height: 43px;
            background-color: var(--background-color-dark);
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center;
        }
    }
}
</style>
